// client/src/coms/e2ee/ReportEvidence.js
// How moderators see a report of encrypted messages: the reported text (the reporter's account), what Voxemera
// checked itself (the encrypted message exists, sender account, sending device, time, ciphertext unchanged), what the
// reporter's device said, and whether others reported the same text. It never claims cryptographic proof of the text.
import React from 'react';
import './e2ee.css';

function when(at) {
  return `${String(at || '').replace('T', ' ').slice(0, 16)} UTC`;
}

export default function ReportEvidence({ evidence, names = {} }) {
  if (!evidence || !evidence.e2ee) return null;
  return (
    <div className="vx-e2ee-evidence" data-testid="e2ee-evidence">
      <span className="vx-set-hint">
        🔒 Encrypted {evidence.scope === 'dm' ? 'direct message' : 'channel message'} report
        {evidence.reporter_status === 'former_member' ? ' · the reporter has since left the server' : ''}
      </span>
      {(evidence.items || []).map((it) => (
        <div key={it.message_id} className="vx-e2ee-evidence-item">
          <div className="vx-e2ee-evidence-text" data-testid="e2ee-evidence-text">
            {it.plaintext}
          </div>
          <span className="vx-set-hint">
            From {names[it.sender_user_id] || `user ${it.sender_user_id}`} · {when(it.sent_at)} · device <code>{it.sender_device_id}</code>
          </span>
          <span className="vx-set-hint">
            Checked by Voxemera: the encrypted message exists and the submitted ciphertext is exactly what was sent
            {it.server_checks && it.server_checks.sending_device_registered ? '; the sending device is registered to that account' : ''}
            {it.server_checks && it.server_checks.sending_device_removed_since ? ' (since removed)' : ''}.
          </span>
          <span className="vx-set-hint">
            Reporter’s device: {it.reporter_device && it.reporter_device.sender_identity_verified ? 'the sender’s identity was verified by the reporter' : 'the sender’s identity was not verified by the reporter'}
            {it.reporter_device && it.reporter_device.restored_from_backup ? '; restored from the reporter’s key backup (sender not confirmed)' : ''}
            {it.reporter_device && it.reporter_device.sending_device_confirmed === false ? '; the reporter’s device could not name the sending device, so the device shown comes from Voxemera’s records only' : ''}.
          </span>
          {it.corroboration && (it.corroboration.same_text_reports || it.corroboration.different_text_reports) ? (
            <span className={it.corroboration.different_text_reports ? 'vx-e2ee-error' : 'vx-set-hint'}>
              {it.corroboration.same_text_reports ? `${it.corroboration.same_text_reports} other report(s) gave the same text. ` : ''}
              {it.corroboration.different_text_reports ? `${it.corroboration.different_text_reports} other report(s) gave a different text for this message.` : ''}
            </span>
          ) : null}
        </div>
      ))}
      <span className="vx-set-hint">{evidence.notice}</span>
    </div>
  );
}
